export const VALIDATION_MESSAGES = {
  required: 'Kötelező mező',
  no_products: 'Nincs kijelölt termék',
  invalid_email: 'Érvénytelen email cím',
  invalid_phone: 'Érvénytelen telefonszám',
  invalid_tax_number: 'Érvénytelen adószám'
  // invalid_cupon: 'Érvénytelen kuponkód'
};
